import { render, staticRenderFns } from "./Counterparties.vue?vue&type=template&id=a130db5e&scoped=true"
import script from "./Counterparties.vue?vue&type=script&lang=js"
export * from "./Counterparties.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a130db5e",
  null
  
)

export default component.exports